import { render, staticRenderFns } from "./pay-1.vue?vue&type=template&id=622da3b2&scoped=true&"
import script from "./pay-1.vue?vue&type=script&lang=js&"
export * from "./pay-1.vue?vue&type=script&lang=js&"
import style0 from "./pay-1.vue?vue&type=style&index=0&id=622da3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622da3b2",
  null
  
)

export default component.exports